import React from 'react';
import Head from 'next/head';

const SEARCH_BOX_DATA = `{ "@context": "https://schema.org/", "@type": "WebSite", "name": "Paperless Post", "url": "https://www.paperlesspost.com/", "potentialAction": { "@type": "SearchAction", "target": "https://www.paperlesspost.com/search?q={search_term_string}search_term_string", "query-input": "required name=search_term_string" } }`;

const SeoSearchBoxScript = () => (
  <Head>
    <script
      dangerouslySetInnerHTML={{ __html: SEARCH_BOX_DATA }}
      id="seo-search-box-script"
      key="seo-search-box-script"
      type="application/ld+json"
    />
  </Head>
);

export default React.memo(SeoSearchBoxScript);
